import { Control, Controller, FieldErrors, UseFormRegister } from "react-hook-form";

import { Input, SelectV2 } from "@/modules/common/components";
import {
  MANAGEMENT_COMPANY_STATUS_OPTIONS,
  MANAGEMENT_MODEL_OPTIONS,
  ManagementCompanyStatus,
} from "@/modules/common/types/ManagementCompanies.enum";
import { ManagementCompanyBaseFormData } from "../../schemas";

interface ManagementCompanyFormFieldsProps {
  register: UseFormRegister<ManagementCompanyBaseFormData>;
  control: Control<ManagementCompanyBaseFormData>;
  errors: FieldErrors<ManagementCompanyBaseFormData>;
  showStatus?: boolean;
  requireCnpj?: boolean;
}

const ManagementCompanyFormFields = ({
  register,
  control,
  errors,
  showStatus = true,
  requireCnpj = true,
}: ManagementCompanyFormFieldsProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <div>
        <Input label="Nome Fantasia" markAsRequired {...register("name")} />
        {errors.name && <p className="mt-1 text-xs text-red-500">{errors.name.message}</p>}
      </div>

      <div>
        <Input label="Razão Social" {...register("corporateName")} />
        {errors.corporateName && <p className="mt-1 text-xs text-red-500">{errors.corporateName.message}</p>}
      </div>

      <div>
        <Controller
          name="managementModel"
          control={control}
          render={({ field }) => (
            <SelectV2
              mode="single"
              label="Modelo de Gestão"
              markAsRequired
              placeholder="Selecione o modelo de gestão"
              options={MANAGEMENT_MODEL_OPTIONS}
              value={field.value || undefined}
              onChange={(next) => field.onChange(next ?? "")}
            />
          )}
        />
        {errors.managementModel && <p className="mt-1 text-xs text-red-500">{errors.managementModel.message}</p>}
      </div>

      {showStatus && (
        <div>
          <Controller
            name="status"
            control={control}
            render={({ field }) => (
              <SelectV2
                mode="single"
                label="Status"
                markAsRequired
                options={MANAGEMENT_COMPANY_STATUS_OPTIONS.filter(
                  (option) => option.value !== String(ManagementCompanyStatus.PROVISIONING),
                )}
                value={field.value || undefined}
                onChange={(next) => field.onChange(next ?? "")}
              />
            )}
          />
          {errors.status && <p className="mt-1 text-xs text-red-500">{errors.status.message}</p>}
        </div>
      )}

      <div>
        <Input label="CNPJ" markAsRequired={requireCnpj} maskType="cnpj" {...register("cnpj")} />
        {errors.cnpj && <p className="mt-1 text-xs text-red-500">{errors.cnpj.message}</p>}
      </div>

      <div>
        <Input label="E-mail Principal" maskType="email" {...register("email")} />
        {errors.email && <p className="mt-1 text-xs text-red-500">{errors.email.message}</p>}
      </div>
    </div>
  );
};

export default ManagementCompanyFormFields;
